import React, { lazy } from 'react'
import Loadable from 'app/components/Loadable/Loadable';
const ProductSubSubGroup = Loadable(lazy(() => import("./ProductSubSubGroup")));

const ProductSubSubGroupRoutes = [
    {
        path: '/productsubsubgroup',
        element: <ProductSubSubGroup />,
    },
]

export default ProductSubSubGroupRoutes
